import { createContext, useContext } from 'react';

import type { MapCommands } from '../state/mapCommands';

const MapCommandsContext = createContext<MapCommands | null>(null);

export const MapCommandsProvider = MapCommandsContext.Provider;

export const useMapCommands = (): MapCommands => {
  const commands = useContext(MapCommandsContext);
  if (commands === null) {
    throw new Error('useMapCommands must be used inside <MapCommandsProvider>');
  }
  return commands;
};
